<template>
    <div class="low-diagram">
        <div class="bg-img-wrap">
            <div class="total-wrap" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img class="bg-img" src="../../../../assets/image/diagram/9-05.png" alt srcset />
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="top-switch"
                        :style="`top:${item._top};left:${item._left};`"
                    >
                        <template v-if="item.isOn == 1">
                            <img
                                src="../../../../assets/image/diagram/guan-new.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>
                        <template v-else>
                            <img
                                src="../../../../assets/image/diagram/kai-new.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>
                        <!-- <template v-else>
                            <img
                                src="../../../../assets/image/diagram/error.png"
                                alt
                                srcset
                                class="kaiguan"
                            />
                        </template>-->
                    </div>
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top};left:${item.left};`"
                        @click="showdialog(item)"
                    >
                        <template>
                            <div class="data-item">
                                <div class="data-name yellow">电压</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ia }}
                                    <span>kV</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="data-name yellow">总有功功率</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ib }}
                                    <span>kW</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="data-name yellow">功率因数</div>
                                <div class="data-number diagram-input-bg">
                                    {{ item.ic }}
                                    <span></span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <ElecDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
    </div>
</template>
<script>
import * as api from "@/http/http-60.js";
import ElecDialog from "./elec-diagram-dialog.vue"
export default {
    components: {
        ElecDialog
    },
    data() {
        return {
            diagramType: 1,
            left: "0",
            top: "30",
            scale: 1,
            basisUnitV: 1,
            basisUnitH: 1,
            scaleIcon: 0.5,
            dialogVisible: false,
            data_id: "",
            dialogTitle: "",
            datas: [
                {
                    point_id: "1464046125509148672",
                    name: "13模铝大拉#1(左)", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "4.75%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "1%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464046272716636160",
                    name: "13模铝大拉#1(右)", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "12.5%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "9%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464048144470933504",
                    name: "13模铜退火", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "20.25%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "17%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464046628041293824",
                    name: "150挤塑机", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "28.05%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "25%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464046534017581056",
                    name: "200挤塑机", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "35.8%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "33%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464045796042375168",
                    name: "35kv交联机#1", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "43.5%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "41%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464048060987506688",
                    name: "1车间挤塑机", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "51.25%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "49%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464045323562418176",
                    name: "8头拉斯机", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "59%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "57%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1463848437895299072",
                    name: "硅烷交联机（左）", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "66.75%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "65%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464047971195846656",
                    name: "空气压缩机", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "74.5%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "72.5%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464045606149455872",
                    name: "韧炼炉", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "82.2%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "80%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
                {
                    point_id: "1464045099246845952",
                    name: "温水交联", //主线名称
                    // 开关
                    _top: "18%",
                    _left: "90.05%",
                    isOn: -1,  //1默认连通  红色；  0断开  绿色
                    // 数据
                    top: "55%",
                    left: "88%",
                    ia: "0",
                    ib: "0",
                    ic: "0",
                },
            ],
            timer: null,
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 10000);
        },
        getData() {
            let pointIds = [];
            this.datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    // 电压（平均）
                    let tempV = (parseFloat(point && point.v_a) + parseFloat(point && point.v_b) + parseFloat(point && point.v_c)) / 1000 / 3;
                    item.ia = tempV.toFixed(2);
                    // 总有功功率(求和)
                    let tempP = parseFloat(point && point.p_a) + parseFloat(point && point.p_b) + parseFloat(point && point.p_c);
                    item.ib = tempP.toFixed(2);
                    // 功率因数（平均）
                    let tempPf = (parseFloat(point && point.pf_a) + parseFloat(point && point.pf_b) + parseFloat(point && point.pf_c)) / 3;
                    item.ic = tempPf.toFixed(2);
                    // A相电压有数据时，isOn为1 否则为0
                    // if (point && point.is_offline) {
                    item.isOn = point.is_offline == 1 ? 0 : 1
                    // } else {
                    //     item.isOn = -1;
                    // }
                });
            });
        },
        showdialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.low-diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;

    h2 {
        color: #fff;
        line-height: 1.8rem;
        text-indent: 2.5rem;
        font-size: 16px;
        float: left;
    }

    .bg-img-wrap {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        .kaiguan {
            width: 4.5rem;
            height: auto;
        }
        .update-time {
            position: absolute;
            top: -1%;
            left: 11%;
            font-size: 0.8rem;
            color: #fff;
        }
        .total-wrap {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;

            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }
            }

            .top-switch {
                // cursor: pointer;
                transform: scale(0.4);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .bottom-switch {
                // cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .bottom-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .data-wrap {
                position: absolute;
                display: grid;
                transform: scale(0.85);

                .data-item {
                    display: flex;
                    margin-bottom: 0.1rem;

                    .data-name {
                        align-self: center;
                        font-size: 0.8rem;
                        margin-right: 0.1rem;
                        width: 4rem;
                        text-align: right;
                        font-weight: bold;
                    }

                    .data-number {
                        font-size: 0.8rem;
                        width: 4.8rem;
                        text-align: right;
                        // background-color: #114aa5;
                        color: #fff;
                        height: 1.2rem;
                        line-height: 1.2rem;

                        nowrap span {
                            display: inline-block;
                            margin-left: 0.2rem;
                            margin-right: 0.2rem;
                        }
                    }

                    .data-u {
                        height: 1.1rem;
                        line-height: 1.1rem;
                    }

                    .data-name-u {
                        font-size: 0.9rem;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }
    .red {
        color: #fe0101;
    }

    .yellow {
        color: #fefa00;
    }

    .green {
        color: #00b200;
    }
}
</style>
